module.exports = __webpack_public_path__ + "img/header.43444db1.png";